module.exports = __webpack_public_path__ + "static/media/dollar-sign.a038ddac.svg";